import { Component } from '@angular/core';
import { CoreSignalCertificationEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Certifications') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-coresignalcertification-form',
    templateUrl: './coresignalcertification.form.component.html'
})
export class CoreSignalCertificationFormComponent extends BaseFormComponent {
    public record!: CoreSignalCertificationEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

